// --------------------------------------------------------------------------
// gallerySlider.js
// --------------------------------------------------------------------------
// Uses fancybox to create lightbox image gallery
// --------------------------------------------------------------------------

RN.gallerySlider = function() {

  'use strict';

  function init() {
    byBehaviour('gallery-slider').slick();
  }

  return {
    init: init
  };

}();
